import { Map as ImmutableMap } from 'immutable';
import { keyIn, deepMergeWithoutListConcatenation
// @ts-expect-error not migrated yet
} from 'ContentEditorUI/lib/immutableHelpers';
// @ts-expect-error not migrated yet
import { getAllFieldNamesOnModuleSpec } from 'ContentEditorUI/data/moduleUtils';
import get from 'hs-lodash/get';
import isEmpty from 'hs-lodash/isEmpty';
import mergeWith from 'hs-lodash/mergeWith';
const EmptyMap = ImmutableMap();
const EmptyObject = Object.freeze({});
export const NON_BODY_ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET = ['child_css', 'css', 'definition_id', 'smart_objects', 'smart_type', 'version', 'selectedSmartRuleId', 'merge_in_default_values', 'label'];
const ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET = [...NON_BODY_ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET, 'body'];

// Schema only info, not needed on the params/body
export const SCHEMA_ONLY_ATTRIBUTES = ['label', 'type', 'overrideable', 'module_id', 'field_types', 'name', 'widget_name', 'path', 'parent_name', 'sourceContainsPostBody', 'has_uneditable_smart_rules', 'export_to_template_context', 'is_global', 'line_number', 'merge_in_default_values'

// TODO, also put `id` here (and remove from ATTRIBUTES_NOT_NEEDED_INSIDE_PARAMS)?
// TODO, also put `order` here?
// TODO, also put `tag` here?
// TODO, also put `wrap_field_tag` here?
// TODO, also put `body` here to prevent nested bodies?
// TODO, also put `label` here?
];
export const ATTRIBUTES_PRIMARILY_FROM_CONTENT_WIDGET_WITH_EMPTY_SCHEMA_WIDGET = [...ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET, ...SCHEMA_ONLY_ATTRIBUTES];
export const ATTRIBUTES_NOT_NEEDED_INSIDE_PARAMS = [...SCHEMA_ONLY_ATTRIBUTES, 'body',
// Acccidental that some layout_section_widgets have .body.body ?
'label',
// Same as ^, I think?
'section_type',
// Same as ^, I think?

// BE internal stuff
'_layout_section_depth', '_layout_section_last_row_depth', '_layout_section_row_number_at_current_depth', 'tag' // I think internal?

// Note, in layout_section_widgets, why is the order set at `w.body` and the root (but the root one is always 0)?

// TODO coalesce with PARAMS_TO_EXCLUDE_SET in layout-data-lib/static-1.6468/js/LayoutDataTree/serialize.js ?
];
function isSchemaOnlyAttributeToFilter(attributesToFilter, val) {
  return attributesToFilter.includes(val);
}
function deepMergeWithoutArrayMerging(valueA, valueB) {
  if (valueA && !Array.isArray(valueA) && !Array.isArray(valueB)) {
    return undefined;
  }
  return valueB;
}
const filterOutSchemaOnlyKeys = (map, fieldNames = []) => {
  // Filter out all SCHEMA_ONLY_ATTRIBUTES _except_ if that is the name of a field in the custom module
  const attributesToFilter = SCHEMA_ONLY_ATTRIBUTES.filter(attribute => !fieldNames.includes(attribute));
  return map.filterNot(keyIn(...attributesToFilter));
};
const filterOutSchemaOnlyKeysImmer = (map, fieldNames = []) => {
  // Filter out all SCHEMA_ONLY_ATTRIBUTES _except_ if that is the name of a field in the custom module
  const attributesToFilter = SCHEMA_ONLY_ATTRIBUTES.filter(attribute => !fieldNames.includes(attribute));
  return Object.keys(map).reduce((obj, key) => {
    if (isSchemaOnlyAttributeToFilter(attributesToFilter, key)) {
      return obj;
    }
    obj[key] = map[key];
    return obj;
  }, {});
};
export const attributesPickedFromContentWidget = (contentWidget, schemaWidget = EmptyMap, {
  sourcePrefix = '',
  moduleSpec,
  isUngatedToMergeTemplateSchemaBodyIntoContentBody = false
} = {}) => {
  const picked = {};
  let fieldNamesInSchema;
  if (moduleSpec) {
    fieldNamesInSchema = getAllFieldNamesOnModuleSpec(moduleSpec);
  }
  if (contentWidget) {
    const attributes = schemaWidget.isEmpty() ? ATTRIBUTES_PRIMARILY_FROM_CONTENT_WIDGET_WITH_EMPTY_SCHEMA_WIDGET : ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET;
    attributes.forEach(attr => {
      // Layout section attributes come from params (hence the optional prefix)
      const source = sourcePrefix ? contentWidget.get(sourcePrefix) : contentWidget;
      if (source.has(attr)) {
        // @ts-expect-error TS is having a hard time ensuring that source[attr] is the same
        // type as picked[attr] because source[attr] is coerced to unknown
        picked[attr] = source.get(attr);
        if (attr === 'body' && isUngatedToMergeTemplateSchemaBodyIntoContentBody) {
          // Clean up module bodies that have incorrectly had things like module_id, type, etc set on them
          picked[attr] = filterOutSchemaOnlyKeys(picked[attr], fieldNamesInSchema);
          const schemaBody = schemaWidget.get(attr);
          if (schemaBody) {
            const filteredSchemaBody = filterOutSchemaOnlyKeys(schemaBody, fieldNamesInSchema);
            picked[attr] = deepMergeWithoutListConcatenation(filteredSchemaBody, picked[attr]);
          }
        }
        if (attr === 'child_css') {
          ['input', 'button'].forEach(childModule => {
            if (picked.child_css && picked.child_css[childModule]) {
              // @ts-expect-error A lot of really hard things to type in here so just leaving this for now since we know the logic works
              delete picked[attr][childModule][childModule];
            }
          });
        }
      }
    });
  }
  return picked;
};
export const attributesPickedFromContentWidgetImmer = (contentWidget, schemaWidget = EmptyObject, {
  sourcePrefix = '',
  moduleSpec,
  isUngatedToMergeTemplateSchemaBodyIntoContentBody = false
} = {}) => {
  const picked = {};
  let fieldNamesInSchema;
  if (moduleSpec) {
    fieldNamesInSchema = getAllFieldNamesOnModuleSpec(moduleSpec);
  }
  if (contentWidget) {
    const attributes = isEmpty(schemaWidget) ? ATTRIBUTES_PRIMARILY_FROM_CONTENT_WIDGET_WITH_EMPTY_SCHEMA_WIDGET : ATTRIBUTES_TO_PICK_FROM_CONTENT_WIDGET;
    attributes.forEach(attr => {
      // Layout section attributes come from params (hence the optional prefix)
      const source = sourcePrefix ? contentWidget[sourcePrefix] : contentWidget;
      if (source && typeof source === 'object' && Object.hasOwn(source, attr)) {
        // @ts-expect-error TS is having a hard time ensuring that source[attr] is the same
        // type as picked[attr] because source[attr] is coerced to unknown
        picked[attr] = source[attr];
        if (attr === 'body' && isUngatedToMergeTemplateSchemaBodyIntoContentBody) {
          // Clean up module bodies that have incorrectly had things like module_id, type, etc set on them
          picked[attr] = filterOutSchemaOnlyKeysImmer(picked[attr], fieldNamesInSchema);
          const schemaBody = schemaWidget[attr];
          if (schemaBody) {
            const filteredSchemaBody = filterOutSchemaOnlyKeysImmer(schemaBody, fieldNamesInSchema);

            // @ts-expect-error We don't know what would end up on the body
            picked[attr] = mergeWith({}, [filteredSchemaBody, picked[attr]], deepMergeWithoutArrayMerging);
          }
        }
        if (attr === 'child_css') {
          ['input', 'button'].forEach(childModule => {
            if (picked.child_css && picked.child_css[childModule]) {
              // @ts-expect-error A lot of really hard things to type in here so just leaving this for now since we know the logic works
              delete picked[attr][childModule][childModule];
            }
          });
        }
      }
    });
  }
  return picked;
};

/* eslint-disable consistent-return */
export const getContentWidgetForWidgetOutsideContainer = (widgetSchema, contentWidgets) => {
  const contentWidget = contentWidgets && widgetSchema && contentWidgets.get(widgetSchema.get('name'));
  if (contentWidget && !contentWidget.get('deleted_at')) {
    return contentWidget;
  }
};

/* eslint-disable consistent-return */
export const getContentWidgetForWidgetOutsideContainerImmer = (widgetSchema, contentWidgets) => {
  const contentWidget = contentWidgets && widgetSchema && contentWidgets[widgetSchema.name];
  if (contentWidget && !contentWidget.deleted_at) {
    return contentWidget;
  }
};

/* eslint-enable consistent-return */

// These functions are yet another iteration (from now removed `normalizedIdentifiers`) that has
// baby-stepped us slightly more towards a world that is more based on module _names_ (but still
// defers to kinda weird old logic that may only be needed for flex columns)
const findIntegerId = (schemaWidget, contentWidget) => {
  if (schemaWidget == null || schemaWidget.isEmpty()) {
    // @ts-expect-error TODO: So many different module types to fix later
    return contentWidget.get('id');
    // @ts-expect-error TODO: So many different module types to fix later
  } else if (typeof schemaWidget.get('key') === 'number') {
    // @ts-expect-error TODO: So many different module types to fix later
    return schemaWidget.get('key'); // this should match contentWidget.id
  }
  return undefined;
};
const findIntegerIdImmer = (schemaWidget, contentWidget) => {
  if (!contentWidget) {
    return undefined;
  }
  if (schemaWidget == null || Object.keys(schemaWidget).length === 0) {
    // @ts-expect-error TODO: So many different module types to fix later
    return contentWidget.id;
    // @ts-expect-error TODO: So many different module types to fix later
  } else if (typeof schemaWidget.key === 'number') {
    // @ts-expect-error TODO: So many different module types to fix later
    return schemaWidget.key; // this should match contentWidget.id
  }
  return undefined;
};

// The "key" identifier seems to mostly be a legacy identifier, that is referenced some in older
// Backbone-ish widget model/collection code. Though we believe it is still necessary for flex columns,
// because name and id are not always there (only when added? only in the schema/default content?).
export const normalizedKey = (schemaWidget, contentWidget) => {
  return findIntegerId(schemaWidget, contentWidget) || schemaWidget.get('name');
};
export const normalizedKeyImmer = (schemaWidget, contentWidget) => {
  return findIntegerIdImmer(schemaWidget, contentWidget) || schemaWidget.name;
};
export const normalizedId = (schemaWidget, contentWidget) => {
  const integerId = findIntegerId(schemaWidget, contentWidget);

  // "name" is the preferred indentifier, but fall back to
  //  - `widget_${key}` from schema if it exists
  //  - and then an ID on the "content widget" if the schema is missing IDs or empty
  //
  // We believe name should be set most of the time, except for...?
  //  - New/default modules in flex columns?
  //  - Old data from long ago?
  if (schemaWidget && schemaWidget.get('name')) {
    return schemaWidget.get('name');
  } else if (integerId) {
    return `widget_${integerId}`;
    // @ts-expect-error TODO: So many different module types to fix later
  } else if (contentWidget && contentWidget.get('id')) {
    // @ts-expect-error TODO: So many different module types to fix later
    return contentWidget.get('id');
  }
  return undefined;
};
export const normalizedIdImmer = (schemaWidget, contentWidget) => {
  const integerId = findIntegerIdImmer(schemaWidget, contentWidget);

  // "name" is the preferred indentifier, but fall back to
  //  - `widget_${key}` from schema if it exists
  //  - and then an ID on the "content widget" if the schema is missing IDs or empty
  //
  // We believe name should be set most of the time, except for...?
  //  - New/default modules in flex columns?
  //  - Old data from long ago?
  if (schemaWidget && schemaWidget.name) {
    return schemaWidget.name;
  } else if (integerId) {
    return `widget_${integerId}`;
    // @ts-expect-error TODO: So many different module types to fix later
  } else if (contentWidget && contentWidget.id) {
    // @ts-expect-error TODO: So many different module types to fix later
    return contentWidget.id;
  }
  return undefined;
};
export const defaultContentWidgetAttributes = (schemaWidget = EmptyMap, contentWidget = EmptyMap) => {
  return ImmutableMap({
    css: contentWidget.get('css') || schemaWidget.get('css') || EmptyMap,
    child_css: contentWidget.get('child_css') || schemaWidget.get('child_css') || EmptyMap,
    styles: contentWidget.get('styles') || EmptyMap,
    smart_type: contentWidget.get('smart_type') || schemaWidget.get('smart_type') || null
  });
};
export const defaultContentWidgetAttributesImmer = (schemaWidget = EmptyObject, contentWidget = EmptyObject) => {
  return {
    css: contentWidget.css || schemaWidget.css || EmptyObject,
    child_css: contentWidget.child_css || schemaWidget.child_css || EmptyObject,
    styles: contentWidget.styles || EmptyObject,
    smart_type: contentWidget.smart_type || schemaWidget.smart_type || null
  };
};
const isV1LogoBuiltin = widgetSchema => {
  return widgetSchema.get('type') === 'logo';
};
const isV1LogoBuiltinImmer = schemaWidget => {
  return schemaWidget.type === 'logo';
};
const fixupLogoWidgetForEditor = widgetSchema => {
  if (widgetSchema.getIn(['body', 'src'])) {
    return widgetSchema.get('body').merge(Object.assign({}, widgetSchema.body, {
      override_inherited_src: true
    }));
  } else if (!widgetSchema.getIn(['body', 'override_inherited_src'])) {
    return widgetSchema.merge(Object.assign({}, widgetSchema.body, {
      alt: '',
      src: null
    }))
    // @ts-expect-error may be here since it is part of the logo module
    .remove('width')
    // @ts-expect-error may be here since it is part of the logo module
    .remove('height');
  }
  return widgetSchema;
};
const fixupLogoWidgetForEditorImmer = schemaWidget => {
  if (get(schemaWidget, ['body', 'src'])) {
    return Object.assign({}, schemaWidget.body, {
      override_inherited_src: true
    });
  } else if (!get(schemaWidget, ['body', 'override_inherited_src'])) {
    const updatedWidget = Object.assign({}, schemaWidget, schemaWidget.body, {
      alt: '',
      src: null
    });
    // @ts-expect-error may be here since it is part of the logo module
    delete updatedWidget.width;
    // @ts-expect-error may be here since it is part of the logo module
    delete updatedWidget.height;
    return updatedWidget;
  }
  return schemaWidget;
};
export const getWidgetBodyFromSchema = (widgetSchema = EmptyMap) => {
  if (widgetSchema.get('body')) {
    if (isV1LogoBuiltin(widgetSchema)) {
      return fixupLogoWidgetForEditor(widgetSchema);
    }
    return widgetSchema.get('body');
  }
  return EmptyMap;
};
export const getWidgetBodyFromSchemaImmer = (schemaWidget = EmptyObject) => {
  if (schemaWidget.body) {
    if (isV1LogoBuiltinImmer(schemaWidget)) {
      return fixupLogoWidgetForEditorImmer(schemaWidget);
    }
    return schemaWidget.body;
  }
  return EmptyObject;
};